import { MiddlewareAPI } from 'redux';
import { getType } from 'typesafe-actions';
import { metrics } from '../../timers/metrics/metrics';
import { Next } from '../../types/redux';
import { State } from '../../types/state';
import {
  confirmAnnotation,
  nextAnnotation,
  postponeAnnotation,
} from '../modules/annotation/actions';
import { validateFulfilled } from '../modules/datapoints/actions';
import { isViewerRole } from '../modules/groups/helpers';
import { startValidation } from '../modules/ui/actions';
import { RootActionType } from '../rootActions';

export default (store: MiddlewareAPI) =>
  (next: Next) =>
  (action: RootActionType) => {
    const state: State = store.getState();
    const { url: organizationUrl } = state.organization;
    switch (action.type) {
      case getType(startValidation): {
        metrics.startAnnotationNext();
        break;
      }

      case getType(nextAnnotation): {
        metrics.startAnnotationNext();
        break;
      }
      case getType(confirmAnnotation): {
        metrics.startAnnotationConfirm();
        break;
      }
      case getType(postponeAnnotation): {
        metrics.startAnnotationPostpone();
        break;
      }

      case getType(validateFulfilled): {
        const { groups, user, annotation } = state;
        const { queue, url: annotationUrl } = annotation;

        const isEnableSaveMetricsToElastic = !isViewerRole(user.groups, groups);

        if (organizationUrl && queue && annotationUrl) {
          metrics.stopAnnotationValidateAndSendResults({
            organization: organizationUrl,
            queue,
            annotation: annotationUrl,
            logMetrics: isEnableSaveMetricsToElastic,
          });
        }
        break;
      }
      default:
        break;
    }
    return next(action);
  };
